import { useCarrierMe, type useCarrierDispatchCenters } from "@/api/carrier";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { hasHttpStatus } from "@/lib/api-error";

export function PickupDispatchGuidance({
  query,
}: {
  query: Pick<
    ReturnType<typeof useCarrierDispatchCenters>,
    "error" | "refetch" | "isFetching"
  >;
}) {
  const me = useCarrierMe();
  const forbidden = hasHttpStatus(query.error, 403);
  return (
    <Alert
      variant={query.error ? "destructive" : "default"}
      role={query.error ? "alert" : "status"}
    >
      <AlertTitle>
        {query.error
          ? "Dispatch centers unavailable"
          : "Dispatch center required"}
      </AlertTitle>
      <AlertDescription>
        <p>
          {forbidden
            ? "You do not have permission to view dispatch centers. Contact your carrier administrator."
            : query.error
              ? "Dispatch centers could not be loaded. Retry before changing setup."
              : "Pickup rates and booking windows need a dispatch center for this carrier."}
        </p>
        {!query.error &&
          (me.isLoading ? (
            <p>Checking setup permissions…</p>
          ) : me.data?.capabilities.canManageCarrierSettings ? (
            <Button asChild variant="outline" size="sm-touch">
              <a
                href="/settings/dispatch-centers"
                target="_blank"
                rel="noreferrer"
              >
                Manage dispatch centers
              </a>
            </Button>
          ) : (
            <p>
              Ask your carrier administrator to configure a dispatch center.
            </p>
          ))}
        {!forbidden && (
          <Button
            variant="outline"
            size="sm-touch"
            disabled={query.isFetching}
            onClick={() => void query.refetch()}
          >
            {query.error
              ? "Retry dispatch centers"
              : "Refresh dispatch centers"}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
